import React, { useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  setSelectedLocation,
  addLocation,
  updateLocation,
  removeLocation,
} from "../../Components/redux/locationsSlice";
import {
  locations1,
  locations2,
  locations3,
  locations4,
  locations5,
  locations6,
  locations7,
  locations8,
} from "../../assets/images";

const Locations = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [products, setProducts] = useState([]);

  const userId = useSelector((state) => state.user.id);
  const locations = useSelector((state) => state.locations.items);
  const selectedLocationId = useSelector(
    (state) => state.locations.selectedLocationId
  );
  const cartItems = useSelector((state) => state.cartItems.items);

  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState({
    name: "",
    mobile: "",
    address: "",
    city: "",
    deliveryLocation: "Mağazadan özüm götürmək",
    deliveryPrice: 0,
  });

  const [editModalOpen, setEditModalOpen] = useState(false);
  const [editData, setEditData] = useState({
    id: null,
    name: "",
    mobile: "",
    address: "",
    city: "",
    deliveryLocation: "Mağazadan özüm götürmək",
    deliveryPrice: 0,
  });

  useEffect(() => {
    const fetchProducts = async () => {
      const res = await axios.get(
        "https://www.elzabeauty.az/elza/dashboard.php"
      );
      setProducts(res.data.data || []);
    };
    fetchProducts();
  }, []);

  const getProductById = (id) => products.find((p) => p.id == id);

  const orderPrice = cartItems.reduce((total, item) => {
    const product = getProductById(item.product_id);
    if (!product) return total;
    const price = parseFloat(product.secondPrice || product.firstPrice || 0);
    return total + price * item.quantity;
  }, 0);

  useEffect(() => {
    if (locations.length > 0 && !selectedLocationId) {
      dispatch(setSelectedLocation(locations[0].id));
    }
  }, [locations, selectedLocationId, dispatch]);

  const handleAddLocationModal = async () => {
    const { name, mobile, address, city, deliveryLocation, deliveryPrice } =
      modalData;
    if (
      !name ||
      !mobile ||
      !address ||
      !city ||
      !deliveryLocation 
    )
      return;

    try {
      const params = new URLSearchParams();
      params.append("user_id", userId);
      params.append("name", name);
      params.append("mobile", mobile);
      params.append("address", address);
      params.append("city", city);
      params.append("deliveryLocation", deliveryLocation);
      params.append("deliveryPrice", deliveryPrice);

      const res = await axios.post(
        "https://www.elzabeauty.az/elza/locations.php",
        params
      );
      if (res.data.status === 1) {
        const newId = res.data.data?.id;
        if (newId) {
          dispatch(
            addLocation({
              id: newId,
              name,
              mobile,
              address,
              city,
              deliveryLocation,
              deliveryPrice,
            })
          );
          dispatch(setSelectedLocation(newId));
          setModalData({
            name: "",
            mobile: "",
            address: "",
            city: "",
            deliveryLocation: "",
            deliveryPrice: 0,
          });
          setShowModal(false);
        }
      }
    } catch (error) {
      console.error("Yeni ünvan əlavə olunmadı:", error);
    }
  };

  const handleSaveEditModal = async () => {
    const { id, name, mobile, address, city, deliveryLocation, deliveryPrice } =
      editData;
    if (
      !id ||
      !name ||
      !mobile ||
      !address ||
      !city ||
      !deliveryLocation 
    )
      return;

    try {
      const params = new URLSearchParams();
      params.append("id", id);
      params.append("name", name);
      params.append("mobile", mobile);
      params.append("address", address);
      params.append("city", city);
      params.append("deliveryLocation", deliveryLocation);
      params.append("deliveryPrice", deliveryPrice);

      const res = await axios.post(
        "https://www.elzabeauty.az/elza/locations.php",
        params
      );

      if (res.data.status === 1) {
        dispatch(
          updateLocation({
            id,
            name,
            mobile,
            address,
            city,
            deliveryLocation,
            deliveryPrice,
          })
        );
        setEditModalOpen(false);
        setEditData({
          id: null,
          name: "",
          mobile: "",
          address: "",
          city: "",
          deliveryLocation: "",
          deliveryPrice: 0,
        });
      }
    } catch (error) {
      console.error("Ünvan redaktə edilə bilmədi:", error);
    }
  };

  const handleDeleteLocation = async (id) => {
    try {
      const params = new URLSearchParams();
      params.append("id", id);

      const res = await axios.delete(
        "https://www.elzabeauty.az/elza/locations.php",
        { data: params }
      );
      if (res.data.status === 1) {
        dispatch(removeLocation(id));
        if (selectedLocationId === id && locations.length > 1) {
          const remaining = locations.find((loc) => loc.id !== id);
          dispatch(setSelectedLocation(remaining.id));
        } else if (locations.length === 1) {
          dispatch(setSelectedLocation(null));
        }
      }
    } catch (error) {
      console.error("Adres silinemedi:", error);
    }
  };

  const handleContinue = () => {
    if (selectedLocationId) {
      navigate(`/${currentLanguage}/orders`);
    }
  };

  if (!userId) {
    return (
      <div className="text-center mt-8">{t("Zəhmət olmasa giriş edin.")}</div>
    );
  }

  return (
    <div className="max-w-containerSm md:max-w-container mx-auto py-10 md:py-20 md:flex justify-between">
      {/* SOL TARAF: Özet + Devam */}
      <div className="md:w-[695px] mb-10 md:mb-0">
        <div className="md:w-[695px]">
          {/* Üst sıra: Çizgiler ve ikonlar */}
          <div className="flex justify-between items-center w-full">
            <div className="w-[94px] bg-[#181D27] h-[2px]"></div>

            <img className="h-11 w-11" src={locations1} alt="Location 1" />

            <div className="w-[187px] bg-[#181D27] h-[2px]"></div>

            <img className="h-11 w-11" src={locations2} alt="Location 2" />

            <div className="w-[76px] bg-[#181D27] h-[2px]"></div>
            <div className="w-[112px] bg-[#E2E2E2] h-[2px]"></div>

            <img className="h-11 w-11" src={locations3} alt="Location 3" />

            <div className="w-[94px] bg-[#E2E2E2] h-[2px]"></div>
          </div>

          {/* Alt sıra: Yazılar */}
          <div className="flex justify-between mt-2 text-secondColor w-full text-[10px] md:text-[16px]">
            <div className="w-[51px]"></div>
            <div className="w-11 text-center">{t("Giriş/Qeydiyyat")}</div>
            <div className="w-[155px]"></div>
            <div className="w-11 text-center">{t("Çatdırılma")}</div>
            <div className="w-[164px]"></div>
            <div className="w-11 text-center">{t("Ödəniş")}</div>
            <div className="w-[78px]"></div>
          </div>
        </div>
        <div className="mt-10 md:mt-20">
          <h2 className="text-[20px] md:text-[24px] font-medium text-firstColor">
            {t("Göndərmə  ünvanını seçin")}
          </h2>
          <ul className="space-y-4 mt-6 md:mt-10">
            {locations.map((loc) => (
              <li
                key={loc.id}
                className={`p-4 border rounded-md flex justify-between items-center cursor-pointer ${
                  selectedLocationId === loc.id ? "border-blue-500" : ""
                }`}
                onClick={() => dispatch(setSelectedLocation(loc.id))}
              >
                <div className="flex justify-between w-full">
                  <div>
                    <div>
                      <strong>{loc.name}</strong>
                    </div>
                    <div>{loc.mobile}</div>
                    <div>{loc.address}</div>
                  </div>
                  <div className="flex items-center gap-4">
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        setEditModalOpen(true);
                        setEditData({ ...loc });
                      }}
                    >
                      <img alt="Edit" className="h-6 w-6" src={locations7}></img>
                    </button>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDeleteLocation(loc.id);
                      }}
                    >
                      <img alt="Trash" className="h-6 w-6" src={locations8}></img>
                    </button>
                  </div>
                </div>
              </li>
            ))}
          </ul>

          <div className="mt-5">
            <div
              onClick={() => setShowModal(true)}
              className="border border-[#E2E2E2] rounded-lg w-full p-6 flex cursor-pointer"
            >
              <img
                alt="New location"
                className="h-6 w-6 mr-5"
                src={locations4}
              ></img>
              <p className="text-firstColor text-[20px]">
                {t("Yeni ünvan əlavə et")}
              </p>
            </div>
          </div>

          <div className="flex justify-between md:justify-normal mt-10 gap-2 md:gap-4">
            <a className="w-1/2" href={`/${currentLanguage}/cart`}>
              <div className="md:w-[340px] h-[52px] rounded-lg border border-[#181D27] flex justify-center items-center font-medium">
                <img alt="Cart" className="h-6 w-6 mr-2" src={locations5}></img>
                <p>{t("Səbətim")}</p>
              </div>
            </a>
            <button
              onClick={handleContinue}
              disabled={!selectedLocationId}
              className={`px-4 py-2 rounded text-white w-1/2 md:w-[340px] flex justify-center items-center transition ${
                selectedLocationId
                  ? "bg-[#181D27]"
                  : "bg-gray-400 cursor-not-allowed"
              }`}
            >
              {t("Davam et")}
              <img
                alt="Continue to location"
                className="h-6 w-6 ml-2"
                src={locations6}
              ></img>
            </button>
          </div>
        </div>
      </div>

      {/* SAĞ TARAF: Özet + Devam */}
      <div className="md:w-[505px] mt-10 md:mt-0 border border-[#E2E2E2] rounded-[20px] p-5 max-h-[200px]">
        <p className="text-[#181D27] text-[20px] md:text-[24px] font-semibold">
          {t("Ödəniş")}
        </p>
        <div className="h-[1px] w-full bg-[#E2E2E2] my-5"></div>
        <div className="flex justify-between">
          <p className="text-[18px] md:text-[20px] font-medium text-[#181D27]">
            {t("Qiymət")}:
          </p>
          <p className="text-[18px] md:text-[20px] font-medium text-[#181D27]">
            {orderPrice.toFixed(2)} ₼
          </p>
        </div>
        {/* <div className="flex justify-between mt-4">
          <p className="text-[20px] font-medium text-[#181D27]">
            {t("Çatdırılma")}:
          </p>
          <p className="text-[20px] font-medium text-[#181D27]">
            {deliveryPrice.toFixed(2)} ₼
          </p>
        </div>
         <div className="flex justify-between mt-4">
          <p className="text-[20px] font-medium text-[#181D27]">
            {t("Ümumi")}:
          </p>
          <p className="text-[20px] font-medium text-[#181D27]">
            {orderPrice.toFixed(2)} + {deliveryPrice.toFixed(2)}  ₼
          </p>
        </div> */}
      </div>
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 text-firstColor">
          <div className="bg-white p-4 md:p-10 rounded-lg w-full md:w-[844px] relative max-w-containerSm md:max-w-container mx-auto">
            <h2 className="text-[20px] md:text-[24px] font-medium text-center">
              {t("Yeni ünvan əlavə et")}
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-10">
              <div>
                {" "}
                <p className="text-firstColor text-[14px] font-medium mb-[5px]">
                  {t("Ad, Soyad, Ata adı")}
                </p>{" "}
                <input
                  type="text"
                  placeholder={t("Ad")}
                  value={modalData.name}
                  onChange={(e) =>
                    setModalData({ ...modalData, name: e.target.value })
                  }
                  className="w-full p-3 border rounded-lg h-[48px]"
                />
              </div>
              <div>
                <p className="text-firstColor text-[14px] font-medium mb-[5px]">
                  {t("Mobil Nömrə")}
                </p>{" "}
                <input
                  type="text"
                  placeholder={t("Mobil nömrə")}
                  value={modalData.mobile}
                  onChange={(e) =>
                    setModalData({ ...modalData, mobile: e.target.value })
                  }
                  className="w-full p-3 border rounded-lg h-[48px]"
                />{" "}
              </div>
              <div>
                <p className="text-firstColor text-[14px] font-medium mb-[5px]">
                  {t("Şəhər")}
                </p>{" "}
                <input
                  type="text"
                  placeholder={t("Şəhər")}
                  value={modalData.city}
                  onChange={(e) =>
                    setModalData({ ...modalData, city: e.target.value })
                  }
                  className="w-full p-3 border rounded-lg h-[48px]"
                />{" "}
              </div>
            </div>
            <div className="mt-6">
              <p className="text-firstColor text-[14px] font-medium mb-[5px]">
                {t("Ünvan")}
              </p>
              <textarea
                placeholder={t("Ünvan")}
                value={modalData.address}
                onChange={(e) =>
                  setModalData({ ...modalData, address: e.target.value })
                }
                className="w-full p-3 border rounded-lg h-[142px] resize-none"
              />
            </div>
            <div className="mt-6">
              <p className="text-firstColor text-[14px] font-medium mb-[5px]">
                {t("Çatdırılma ünvanı")}
              </p>

              <select
                value={modalData.deliveryLocation}
                onChange={(e) => {
                  const selected = e.target.value;

                  // Qiymətləri xəritə kimi saxladım
                  const priceMap = {
                    "Mağazadan özüm götürmək": 0,
                    Metrolar: 4,
                    Şəhərdaxili: 6,
                    Poçt: 6,
                    "Yasamal, NZS, Nargilə ərazisi, Neapol dairəsi ərazilər, Gəncə prospekti daxil ərazilər": 7,
                    "Badamdar, Biləcəri, Sabunçu, köhnə Qaraçuxur, Günəşli daxil ərazilər": 8,
                    "Binə, Binəqədi, Xocasən, Sulutəpə, Zığ, Zabrat 1": 9,
                    "Masazır, Binəqədi qəsəbə, Balaxanı, Maştağa, Zabrat 2, köhnə Ramana, Məhəmmədi": 10,
                    "Lökbatan, Qobu, Saray, Ceyranbatan, Sumqayıt, yeni Suraxanı, gülçülük Digah, Fatmayı, Ramana, Hövsan qəsəbə daxil ərazilər": 12,
                  };

                  setModalData({
                    ...modalData,
                    deliveryLocation: selected,
                    deliveryPrice: priceMap[selected], // Qiymət avtomatik dəyişir
                  });
                }}
                className="w-full p-3 border rounded-lg h-[48px] text-firstColor"
              >
                <option value="Mağazadan özüm götürmək">{t("Mağazadan özüm götürmək")} - Ödənişsiz</option>
                <option value="Metrolar">{t("Metrolar")} - 4.00 AZN</option>
                <option value="Şəhərdaxili">
                  {t("Şəhərdaxili")} - 6.00 AZN
                </option>
                <option value="Poçt">{t("Poçt")} - 6.00 AZN</option>
                <option value="Yasamal, NZS, Nargilə ərazisi, Neapol dairəsi ərazilər, Gəncə prospekti daxil ərazilər">
                  {t(
                    "Yasamal, NZS, Nargilə ərazisi, Neapol dairəsi ərazilər, Gəncə prospekti daxil ərazilər"
                  )}{" "}
                  - 7.00 AZN
                </option>
                <option value="Badamdar, Biləcəri, Sabunçu, köhnə Qaraçuxur, Günəşli daxil ərazilər">
                  {t(
                    "Badamdar, Biləcəri, Sabunçu, köhnə Qaraçuxur, Günəşli daxil ərazilər"
                  )}{" "}
                  - 8.00 AZN
                </option>
                <option value="Binə, Binəqədi, Xocasən, Sulutəpə, Zığ, Zabrat 1">
                  {t("Binə, Binəqədi, Xocasən, Sulutəpə, Zığ, Zabrat 1")} - 9.00
                  AZN
                </option>
                <option value="Masazır, Binəqədi qəsəbə, Balaxanı, Maştağa, Zabrat 2, köhnə Ramana, Məhəmmədi">
                  {t(
                    "Masazır, Binəqədi qəsəbə, Balaxanı, Maştağa, Zabrat 2, köhnə Ramana, Məhəmmədi"
                  )}{" "}
                  - 10.00 AZN
                </option>
                <option value="Lökbatan, Qobu, Saray, Ceyranbatan, Sumqayıt, yeni Suraxanı, gülçülük Digah, Fatmayı, Ramana, Hövsan qəsəbə daxil ərazilər">
                  {t(
                    "Lökbatan, Qobu, Saray, Ceyranbatan, Sumqayıt, yeni Suraxanı, gülçülük Digah, Fatmayı, Ramana, Hövsan qəsəbə daxil ərazilər"
                  )}{" "}
                  - 12.00 AZN
                </option>
              </select>
            </div>

            <div className="grid grid-cols-2 gap-7 mt-10">
              <button
                onClick={() => setShowModal(false)}
                className="rounded-lg h-[52px] border-[1px] border-[#181D27] text-firstColor"
              >
                {t("Bağla")}
              </button>
              <button
                onClick={handleAddLocationModal}
                className="rounded-lg h-[52px] text-white bg-[#181D27]"
              >
                {t("Əlavə Et")}
              </button>
            </div>
          </div>
        </div>
      )}

      {editModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 text-firstColor ">
          <div className="bg-white p-4 md:p-10 rounded-lg w-full md:w-[844px] relative mx-auto max-w-containerSm md:max-w-container">
            <h2 className="text-[20px] md:text-[24px] font-medium text-center">
              {t("Ünvanı redaktə et")}
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-10">
              <div>
                {" "}
                <p className="text-firstColor text-[14px] font-medium mb-[5px]">
                  {t("Ad, Soyad, Ata adı")}
                </p>{" "}
                <input
                  type="text"
                  placeholder={t("Ad")}
                  value={editData.name}
                  onChange={(e) =>
                    setEditData({ ...editData, name: e.target.value })
                  }
                  className="w-full p-3 border rounded-lg h-[48px]"
                />
              </div>
              <div>
                <p className="text-firstColor text-[14px] font-medium mb-[5px]">
                  {t("Mobil Nömrə")}
                </p>{" "}
                <input
                  type="text"
                  placeholder={t("Mobil nömrə")}
                  value={editData.mobile}
                  onChange={(e) =>
                    setEditData({ ...editData, mobile: e.target.value })
                  }
                  className="w-full p-3 border rounded-lg h-[48px]"
                />{" "}
              </div>
              <div>
                <p className="text-firstColor text-[14px] font-medium mb-[5px]">
                  {t("Şəhər")}
                </p>{" "}
                <input
                  type="text"
                  placeholder={t("Şəhər")}
                  value={editData.city}
                  onChange={(e) =>
                    setEditData({ ...editData, city: e.target.value })
                  }
                  className="w-full p-3 border rounded-lg h-[48px]"
                />{" "}
              </div>
            </div>
            <div className="mt-6">
              <p className="text-firstColor text-[14px] font-medium mb-[5px]">
                {t("Ünvan")}
              </p>
              <textarea
                placeholder={t("Ünvan")}
                value={editData.address}
                onChange={(e) =>
                  setEditData({ ...editData, address: e.target.value })
                }
                className="w-full p-3 border rounded-lg h-[142px] resize-none"
              />
            </div>
            {/* Çatdırılma Ünvanı + Qiymət */}
            <div className="mt-6">
              <p className="text-firstColor text-[14px] font-medium mb-[5px]">
                {t("Çatdırılma ünvanı")}
              </p>

              <select
                value={editData.deliveryLocation}
                onChange={(e) => {
                  const selected = e.target.value;

                  // Qiymətləri xəritə kimi saxladım
                  const priceMap = {
                    "Mağazadan özüm götürmək": 0,
                    Metrolar: 4,
                    Şəhərdaxili: 6,
                    Poçt: 6,
                    "Yasamal, NZS, Nargilə ərazisi, Neapol dairəsi ərazilər, Gəncə prospekti daxil ərazilər": 7,
                    "Badamdar, Biləcəri, Sabunçu, köhnə Qaraçuxur, Günəşli daxil ərazilər": 8,
                    "Binə, Binəqədi, Xocasən, Sulutəpə, Zığ, Zabrat 1": 9,
                    "Masazır, Binəqədi qəsəbə, Balaxanı, Maştağa, Zabrat 2, köhnə Ramana, Məhəmmədi": 10,
                    "Lökbatan, Qobu, Saray, Ceyranbatan, Sumqayıt, yeni Suraxanı, gülçülük Digah, Fatmayı, Ramana, Hövsan qəsəbə daxil ərazilər": 12,
                  };

                  setEditData({
                    ...editData,
                    deliveryLocation: selected,
                    deliveryPrice: priceMap[selected], // Qiymət avtomatik dəyişir
                  });
                }}
                className="w-full p-3 border rounded-lg h-[48px] text-firstColor"
              >


<option value="Mağazadan özüm götürmək">{t("Mağazadan özüm götürmək")} - Ödənişsiz</option>
                <option value="Metrolar">{t("Metrolar")} - 4.00 AZN</option>
                <option value="Şəhərdaxili">
                  {t("Şəhərdaxili")} - 6.00 AZN
                </option>
                <option value="Poçt">{t("Poçt")} - 6.00 AZN</option>
                <option value="Yasamal, NZS, Nargilə ərazisi, Neapol dairəsi ərazilər, Gəncə prospekti daxil ərazilər">
                  {t(
                    "Yasamal, NZS, Nargilə ərazisi, Neapol dairəsi ərazilər, Gəncə prospekti daxil ərazilər"
                  )}{" "}
                  - 7.00 AZN
                </option>
                <option value="Badamdar, Biləcəri, Sabunçu, köhnə Qaraçuxur, Günəşli daxil ərazilər">
                  {t(
                    "Badamdar, Biləcəri, Sabunçu, köhnə Qaraçuxur, Günəşli daxil ərazilər"
                  )}{" "}
                  - 8.00 AZN
                </option>
                <option value="Binə, Binəqədi, Xocasən, Sulutəpə, Zığ, Zabrat 1">
                  {t("Binə, Binəqədi, Xocasən, Sulutəpə, Zığ, Zabrat 1")} - 9.00
                  AZN
                </option>
                <option value="Masazır, Binəqədi qəsəbə, Balaxanı, Maştağa, Zabrat 2, köhnə Ramana, Məhəmmədi">
                  {t(
                    "Masazır, Binəqədi qəsəbə, Balaxanı, Maştağa, Zabrat 2, köhnə Ramana, Məhəmmədi"
                  )}{" "}
                  - 10.00 AZN
                </option>
                <option value="Lökbatan, Qobu, Saray, Ceyranbatan, Sumqayıt, yeni Suraxanı, gülçülük Digah, Fatmayı, Ramana, Hövsan qəsəbə daxil ərazilər">
                  {t(
                    "Lökbatan, Qobu, Saray, Ceyranbatan, Sumqayıt, yeni Suraxanı, gülçülük Digah, Fatmayı, Ramana, Hövsan qəsəbə daxil ərazilər"
                  )}{" "}
                  - 12.00 AZN
                </option>
              </select>
            </div>

            <div className="grid grid-cols-2 gap-7 mt-10">
              <button
                onClick={() => setEditModalOpen(false)}
                className="rounded-lg h-[52px] border-[1px] border-[#181D27] text-firstColor"
              >
                {t("Ləğv et")}
              </button>
              <button
                onClick={handleSaveEditModal}
                className="rounded-lg h-[52px] text-white bg-[#181D27]"
              >
                {t("Yadda saxla")}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Locations;
